// Thin HTTP client for Chit Chats Print's non-WebSocket endpoints.
//
// After the WebSocket migration Chit Chats Print exposes only:
//
//   GET /health           - liveness
//   GET /v1/printers      - printer enumeration (used by the modal)
//   GET /v1/diagnostics   - support report (used by the setup page)
//   /print                - WebSocket upgrade (handled by ws_flow.js)
//
// This module owns the request helper used for /v1/printers. Base URL
// resolution lives in the base URL module so setup, diagnostics,
// and WebSocket flows cannot drift.

import { getBaseUrl } from "./chit_chats_print_agent_base_url";

function createRequestError(code, message, status) {
  var error = new Error(message || "");
  error.code = code;
  error.status = status;
  return error;
}

function createPrintApiClient(message) {
  return {
    listPrinters() {
      return this.request("GET", "/v1/printers");
    },

    parseResponseBody(raw) {
      if (!raw || raw.length === 0) {
        return {};
      }
      try {
        return JSON.parse(raw);
      } catch (_e) {
        return {};
      }
    },

    responseError(resp, body) {
      var errCode = body.error && body.error.code ? body.error.code : "REQUEST_FAILED";
      var defaultMessage = "Request failed (" + resp.status + ")";
      var errMsg = body.error && body.error.message ? body.error.message : defaultMessage;
      return createRequestError(errCode, errMsg, resp.status);
    },

    normalizeRequestError(error) {
      if (error && error.name === "AbortError") {
        return createRequestError("REQUEST_TIMEOUT", message("print_app_timeout"));
      }
      if (error && error.code) {
        return error;
      }
      if (typeof error === "string") {
        return createRequestError("REQUEST_FAILED", error);
      }
      return createRequestError("PRINT_APP_UNREACHABLE", message("print_app_unreachable"));
    },

    request(method, path, payload, options) {
      var self = this;
      var controller = new AbortController();
      var timeoutMs = (options && options.timeoutMs) || 20000;
      var timeoutId = setTimeout(function() {
        controller.abort();
      }, timeoutMs);

      return fetch(this.baseUrl() + path, {
        method: method,
        headers: { "Content-Type": "application/json" },
        body: (payload ? JSON.stringify(payload) : null),
        signal: controller.signal
      }).then(function(resp) {
        clearTimeout(timeoutId);
        return resp.text().then(function(raw) {
          var body = self.parseResponseBody(raw);
          if (resp.ok) {
            return body;
          }
          throw self.responseError(resp, body);
        });
      }).catch(function(error) {
        clearTimeout(timeoutId);
        throw self.normalizeRequestError(error);
      });
    },

    baseUrl() {
      return getBaseUrl();
    }
  };
}

export { createPrintApiClient };
